import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false
import request from './api/request'
import api from './api/index'
Vue.prototype.request = request;
Vue.prototype.api = api;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
